import type { StateCreator } from 'zustand';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastState {
  message: string;
  type: ToastType;
}

export interface ToastSlice {
  toast: ToastState | null;
  showToast: (message: string, type?: ToastType) => void;
  hideToast: () => void;
}

export const toastInitialState = {
  toast: null as ToastState | null,
};

// Auto-hide timeout reference
let toastTimeoutId: ReturnType<typeof setTimeout> | null = null;

export const createToastSlice: StateCreator<ToastSlice, [], [], ToastSlice> = (
  set
) => ({
  ...toastInitialState,

  showToast: (message, type = 'success') => {
    // Clear existing timeout
    if (toastTimeoutId) {
      clearTimeout(toastTimeoutId);
    }

    set({ toast: { message, type } });

    // Auto-hide after duration
    const duration = type === 'error' ? 4000 : 2000;
    toastTimeoutId = setTimeout(() => {
      set({ toast: null });
      toastTimeoutId = null;
    }, duration);
  },

  hideToast: () => {
    if (toastTimeoutId) {
      clearTimeout(toastTimeoutId);
      toastTimeoutId = null;
    }
    set({ toast: null });
  },
});
